import { apiAction } from 'apa/actions';
import * as types from 'customers/actions/types';
import { BaseUrl } from '../../BaseUrl/BaseUrl';

export const add = (location, history) => dispatch => {
  return dispatch(
    apiAction({
      url: `${BaseUrl}/api/customers/locations/`,
      method: 'POST',
      data: location,
      onSuccess: location => {
        history.push(`/customer/${location.customer}/locations`);
        return {
          type: types.LOCATION_CREATE,
          location: location
        };
      },
      onFailure: error => {
        console.error('Error adding location:', error);
        return Promise.reject(error);
      }
    })
  );
};

export const update = (location, history) => dispatch => {
  return dispatch(
    apiAction({
      url: `${BaseUrl}/api/customers/locations/${location.id}/`,
      method: 'PATCH',
      data: location,
      onSuccess: location => {
        history.push(`/customer/${location.customer}/locations`);
        return {
          type: types.LOCATION_UPDATE,
          location: location
        };
      },
      onFailure: error => {
        console.error('Error updating location:', error);
        return Promise.reject(error);
      }
    })
  );
};

export const remove = (location) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(
      apiAction({
        url: `${BaseUrl}/api/customers/locations/${location.id}/`,
        method: 'DELETE',
        onSuccess: () => {
          dispatch({
            type: types.LOCATION_DELETE,
            location: location
          });
          dispatch(fetchLocations(location.customer));
          resolve();
        },
        onFailure: (error) => {
          reject(error);
        }
      })
    );
  });
};

export const fetchLocations = (customerId) => dispatch => dispatch(
  apiAction({
    url: `${BaseUrl}/api/customers/${customerId}/locations/`,
    method: 'GET',
    onSuccess: locations => ({
      type: types.FETCH_LOCATIONS_SUCCESS,
      locations: locations
    })
  })
);

export const fetchLocation = (locationId) => dispatch => dispatch(
  apiAction({
    url: `${BaseUrl}/api/customers/locations/${locationId}/`,
    method: 'GET',
    onSuccess: location => ({
      type: types.FETCH_LOCATION_SUCCESS,
      location: location
    })
  })
);